var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSpin)?_c('div',{class:_vm.isLeft ? 'spin-sp2' : 'spin-sp1',attrs:{"id":"spin-model"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }